var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export function redirectManagerWorkerSaga(_a) {
    var error_1;
    var _b = _a.payload, pathName = _b.pathName, params = _b.params, actionAfterRedirect = _b.actionAfterRedirect, callbackAfterRedirect = _b.callbackAfterRedirect, actionAfterRedirectParams = _b.actionAfterRedirectParams, navigationParams = _b.navigationParams, router = _a.router, dispatch = _a.dispatch;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!router) {
                    return [2 /*return*/];
                }
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                // eslint-disable-next-line
                // @ts-ignore
                return [4 /*yield*/, router.navigate(pathName, params, navigationParams, function () {
                        if (actionAfterRedirect) {
                            // cast type to dispatch in BaseAction style
                            var action = actionAfterRedirectParams
                                ? actionAfterRedirect.bind(null, __assign({}, actionAfterRedirectParams))
                                : actionAfterRedirect;
                            dispatch(action());
                        }
                        if (callbackAfterRedirect) {
                            callbackAfterRedirect();
                        }
                    })];
            case 2:
                // eslint-disable-next-line
                // @ts-ignore
                _c.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _c.sent();
                console.error('redirectManagerWorkerSaga catch error', error_1.message);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}
